export const APP_ROUTES = [
	{
		id: 'create-test',
		path: '/create-test',
		label: 'Utwórz test',
		order: 1,
	},
	{
		id: 'my-tests',
		path: '/my-tests',
		label: 'Moje testy',
		order: 2,
	},
	{
		id: 'edit-test',
		path: '/edit-test',
		label: 'Edytuj Test',
		order: 0,
	},
];

export const DEFAULT_ROUTE = '/my-tests';
